import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "loadig-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");

  const _component_van_loading = _resolveComponent("van-loading");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view, null, {
    default: _withCtx(({
      Component
    }) => [(_openBlock(), _createBlock(_KeepAlive, null, [!!_ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
      key: 0
    })) : _createCommentVNode("", true)], 1024)), !_ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
      key: 0
    })) : _createCommentVNode("", true)]),
    _: 1
  }), !!_ctx.loadingObj ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_loading, {
    size: "24px",
    color: "#1989fa",
    vertical: ""
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.loadingObj.msg), 1)]),
    _: 1
  })])) : _createCommentVNode("", true)], 64);
}